<template>
	<div class="container" id="topTarget" @scroll="goscroll">
		<div class="title">
			<span @click="go" style="margin-left: 20px;">返回</span>
			<el-divider direction="vertical"></el-divider>

		</div>
		<el-divider>商品详情</el-divider>
		<goods-magnifier-zoom :imgList="detaillist.images.split(',')" style="margin: 50px;"></goods-magnifier-zoom>
		<div style="position: absolute;left: 500px;top: 100px;">
			<p>{{detaillist.goodsName}}</p>

			<div class="detail">
				<div>
					<span>协议价:<span
							style="color: red;font-size: 20px;font-weight: 600;padding-left: 5px;">￥{{detaillist.agreementPrice}}</span>
						
					</span></br>

					<span>指导价：<span
							style="color: red;font-size: 16px;font-weight: 500;padding-left: 5px;">￥{{detaillist.price}}</span></span>
							
							<span
								style="text-decoration: line-through;padding-left: 5px;">[￥{{detaillist.marketPrice}}]</span>
				</div>
				<div>
					<span>已出售 <span style="color: red;padding-right: 10px;">{{detaillist.salesSum}}</span> </span>
					<span style="color: rgba(0, 0, 0, 0.3);">|</span> <span style="padding-left: 10px;">库存 <span
							style="color: red;">{{detaillist.stock}}</span> </span>
				</div>

			</div>
			<div style="margin-top: 50px;height: 180px;">
				<span style="color: #7f7f7f;font-size: 14px;">数量：</span>
				<el-input-number v-model="num" :min="1" :max="100000" label="请输入" size="small"></el-input-number>
			</div>
			<div style="margin-left: 100px;">
				<!-- <el-button type="info" round size="small">加入选品</el-button> -->
				<el-button type="info" round size="medium" style="background: rgb(255, 88, 47);" @click="addnum">加入选品
				</el-button>
			</div>
		</div>

		<div class="detaildt">
			<div>
				<p style="border-left: 4px red solid;margin-left: 20px;padding-left: 10px;">商品详情</p>
				<p style="font-size: 14px;margin-left: 50px;"> <span style="">商品编号：{{detaillist.goodsCode}}</span>
					<span style="padding-left: 100px;">品牌：{{detaillist.brandName}}</span><span
						style="padding-left: 100px;">商家名称：{{detaillist.goodsName}}</span>
				</p>
			</div>
			<div v-html="detaillist.detail" style="padding: 20px;"></div>
		</div>
		<div class="scrollBox" @click="goBack" style="font-size: 30px;position: fixed;bottom: 10px;right: 10px;">⬆️
		</div>
	</div>
</template>

<script>
	import goodsMagnifierZoom from '../../components/goods-zoom.vue';


	export default {
		name: "GoodsZoom",
		components: {
			goodsMagnifierZoom: goodsMagnifierZoom,
		},
		data() {
			return {
				detaillist: {},
				num: 1,

			}
		},
		methods: {
			goscroll(e){
				// console.log(e);
			},
			goBack() {
			  topTarget.scrollIntoView();
			},
			go() {
				this.$router.go(-1)
			},
			addnum() {
				let data = {
					goodsId: this.detaillist.id,
					price: this.detaillist.price
				}
				this.$api.addGood(this.$encrypt(data)).then(res => {
					// console.log(res);
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
					} else {

					}
				})
			}
		},
		created() {

			this.$api.findFxGoods(this.$encrypt({
				id: this.$route.query.id
			})).then(res => {
				res.data=JSON.parse(this.$decrypt(res.data)).data
				// console.log(res.data.list[0].images);
				this.detaillist = res.data.list[0]
				let detail = res.data.list[0].detail
				let aa = detail.replace(/&lt;/g, '<', )
				let bb = aa.replace(/&gt;/g, '>')
				let cc = bb.replace(/&quot;/g, '"')
				this.detaillist.detail = cc
				var info = this.detaillist.detail
				const regex = new RegExp('<img', 'gi');
				this.detaillist.detail = info.replace(regex,
					`<img style="width: 100%; height:auto;display:block"`);
				// console.log(this.detaillist);
			})
		}
	}
</script>

<style>
	/* 新建的项目  去一下默认样式 */
	body,
	html {
		padding: 0;
		margin: 0;
	}
</style>
<style leng="less" scoped>
	.container {
		position: relative;
	}

	.detail {
		background: rgb(244, 249, 254);
		width: 880px;
		height: 60px;
		border-radius: 5px;
		padding: 10px;
		line-height: 30px;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
	}

	.detaildt {
		/* width: 1380px; */
		width: 93%;
		margin: 50px;
		overflow: hidden;
		background: white;
		height: auto;
		border-radius: 10px;
	}
</style>
